import React, { FC, useEffect, useState } from 'react'
import { RouteComponentProps } from "@reach/router"
import _ from 'lodash'
import Isvg from 'react-inlinesvg'
// Components
import { Toolbar } from "components/subnav"
import ImportIcon from "components/import-export/import-icon"
import ExportIcon from "components/import-export/export-icon"
import Import from "components/import-export/import"
import TMIncreaseTable from './tm-increase-table'
// Data
import api_match from "data/interface/api"
import increaseService from "data/increase"
import propertyService from 'data/property'
import inflationService from 'data/inflation'
import importService from "data/import"
//Styles
import { TMIncrease_s } from "components/tenant-market/increase/tm-increase-styles"
import { AddIcon } from "images/icons/tools"

const TMIncrease: FC<RouteComponentProps> = (props) => {
  const [data, setData] = useState<object[]>([])
  const [inflation, setInflation] = useState<object[]>([])
  const [initSort, setInitSort] = useState<boolean>(false)
  const [showImport, toggleShowImport] = useState<boolean>(false)
  const [property, setProperty] = useState<object|null>(null);
  const [propertyId, setPropertyId] = useState(propertyService.getStoredPropertyId())
  const tableId = "tm-increase-table"

  useEffect(() => {
    importService.stream().subscribe(data => {
      toggleShowImport(data['showImport'])
    })

    toggleShowImport(false);

    const increaseSubscription = increaseService.stream().subscribe(data => {
      api_match(
        data,
        init  => setData(init.value),
        ok    => {
          setData(ok.value)
        },
        err   => {
          setData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const propertySubscription = propertyService.stream().subscribe((data) => {
      if (data.value.length > 0){
        setProperty(_.find(data.value, {propertyid: data.current}))
      }
      switch (data.state) {
        case 'ok':
          setPropertyId(data.current)
          break
      }
    })

    const inflationSubscription = inflationService.stream().subscribe(data => {
      api_match(
        data,
        init  => setInflation(init.value),
        ok    => {
          setInflation(ok.value)
        },
        err   => {
          setInflation(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    return function cleanup() {
      increaseSubscription.unsubscribe()
      propertySubscription.unsubscribe()
      inflationSubscription.unsubscribe()
    }
  }, [initSort])

  useEffect(() => {
    if (_.isNil(propertyId)) return

    increaseService.fetchIncrease(propertyId)
    inflationService.fetchInflation(propertyId)
    propertyService.fetchProperty(propertyId)

  }, [propertyId])

  const Add = () => {
    const defaults = property ? {...property['defaultsnameditem']} : {}
    return (
      <a onClick={() => increaseService.create(propertyService.getStoredPropertyId(), defaults)}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }

  return (
    <TMIncrease_s>
      <Toolbar>
        <Add />
        <ImportIcon />
        <ExportIcon template="increase" />
      </Toolbar>
      { showImport && <Import /> }
      { data && property && !showImport && inflation && <TMIncreaseTable tableId={tableId} data={data} defaults={{...property['defaultsnameditem']}} inflationData={inflation} /> }
    </TMIncrease_s>
  )
}

export default TMIncrease
